__turbopack_context__.v({
  "contentColumn": "lead-space-module__cc7a1a__contentColumn",
  "ctaGroup": "lead-space-module__cc7a1a__ctaGroup",
  "frame": "lead-space-module__cc7a1a__frame",
  "grid": "lead-space-module__cc7a1a__grid",
  "heading": "lead-space-module__cc7a1a__heading",
  "leadSpace": "lead-space-module__cc7a1a__leadSpace",
  "leadspace-enter": "lead-space-module__cc7a1a__leadspace-enter",
  "media": "lead-space-module__cc7a1a__media",
  "mediaColumn": "lead-space-module__cc7a1a__mediaColumn",
  "mediaDark": "lead-space-module__cc7a1a__mediaDark",
  "mediaLight": "lead-space-module__cc7a1a__mediaLight",
  "pictoMedia": "lead-space-module__cc7a1a__pictoMedia",
  "subheading": "lead-space-module__cc7a1a__subheading",
});
